import { IUser } from '../../enum/user';
import BeMaccaferriIdentityProvider from './BeMaccaferriIdentityProvider';

export const getUserAsync = async (): Promise<IUser> => {
    let res = await BeMaccaferriIdentityProvider.getUserAsync();
    return {
        email: res.data.email,
        firstName: res.data.firstName,
        lastName: res.data.lastName,
        isAdmin: res.data.isAdmin,
    };
};


export const logoutAsync = async () => {
    let response = await BeMaccaferriIdentityProvider.logoutAsync();
    let isSuccess = response.data;
    if (isSuccess) {
        window.location.href = process.env.EDESIGN_PORTAL_URL as string;
    }
    return response;
};
